import { BookMarked, Sparkles, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ hasCitations, onAdd, searching }) {
  if (searching) {
    return (
      <div className="text-center py-24 fade-slide-in">
        <div className="inline-block p-4 rounded-full bg-[#FCE7F3] dark:bg-[#2E2140] mb-4">
          <Search className="w-8 h-8 text-[#7A6A8C]" />
        </div>
        <h3 className="font-serif-display text-2xl text-[#3B2350] dark:text-[#FBEFF6]">
          Nothing matches your search
        </h3>
        <p className="text-sm text-[#5E4B70] dark:text-[#BBA9CF] mt-2">
          Try a different keyword, or clear the search to see everything.
        </p>
      </div>
    );
  }

  if (hasCitations) {
    return (
      <div className="text-center py-24 fade-slide-in">
        <h3 className="font-serif-display text-2xl text-[#3B2350] dark:text-[#FBEFF6]">
          No citations here yet
        </h3>
        <p className="text-sm text-[#5E4B70] dark:text-[#BBA9CF] mt-2">
          This view is empty &mdash; try a different project or tag filter.
        </p>
      </div>
    );
  }

  return (
    <div
      data-testid="empty-state-welcome"
      className="fade-slide-in relative overflow-hidden rounded-2xl border border-[#F5D0E3] dark:border-[#45325A] bg-white dark:bg-[#3B2350] p-10 sm:p-14"
    >
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-[#C9286F]/5 dark:bg-[#C4A1FF]/10 blur-3xl" />
      <div className="absolute -left-32 -bottom-32 w-96 h-96 rounded-full bg-[#8B5CF6]/5 dark:bg-[#8B5CF6]/10 blur-3xl" />

      <div className="relative max-w-2xl">
        <h2 className="font-serif-display serif-tracking text-4xl sm:text-5xl font-semibold text-[#3B2350] dark:text-[#FBEFF6] leading-tight">
          Your research<br />canvas is empty.
        </h2>
        <p className="mt-5 text-base text-[#5E4B70] dark:text-[#BBA9CF] leading-relaxed max-w-lg">
          Paste a DOI, arXiv link, or article URL and we&apos;ll fetch the authors, journal, year, and abstract for you &mdash; or enter a citation manually. Organize into projects, tag them, and copy a formatted citation in a single click.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <Button
            data-testid="empty-state-add-citation"
            onClick={onAdd}
            className="bg-[#C9286F] hover:bg-[#B8246C] dark:bg-[#C4A1FF] dark:hover:bg-[#A982F0] text-white gap-2 h-11 px-5"
          >
            <BookMarked className="w-4 h-4" /> Add your first citation
          </Button>
          <div className="text-xs text-[#7A6A8C] font-mono-scholar">
            Try: <code className="px-2 py-1 bg-[#FCE7F3] dark:bg-[#2E2140] rounded">10.1038/s41586-020-2649-2</code>
          </div>
        </div>
      </div>
    </div>
  );
}
